export default __webpack_public_path__ + "static/media/Prancheta.816a5766.svg";